import React, { useState, useEffect } from 'react';
import { Cinema } from './Cinema';
import styles from './Cinemas.module.scss';

const Cinemas = (props) => {
  const { 
    location,
    useCurrentLocation,
    cinemas,
    setFilter,
    isPopup,
    homeURL,
    useSiteAsFilter,
    setActiveTab,
    colorScheme,
    concessionBtnText,
    concessionSiteLink,
    concessionLinkNewTab,
    concessionEnabledParam,
    testCinemasEnabled
  } = props

  const [cinemasList, setCinemasList] = useState([]);

  const searchRadius = 1320;
  const isDropDownLayout = !!document.querySelector('.popup__choose-cinema.as-drop-down');

  useEffect(() => {
    if (!useCurrentLocation && !location) {
      // list all cinemas by default since "Use current location" option is not used
      setCinemasList(cinemas);
      // setCinemasList([]);
    } else if (!useCurrentLocation && location) {
      const filterCinemas = (searchTerm) => {
        if (!searchTerm || searchTerm.length < 2) {
          setCinemasList([]);
        } else {
          const filteredCinemas = cinemas.filter(cinema => {
            return searchTerm === cinema.postCode || cinema.address?.indexOf(searchTerm) !== -1;
          });

          setCinemasList(filteredCinemas);
        }
      }
      
      filterCinemas(location);
    } else { // use current location
      const filterAreaCinemas = () => {
        const currentCoords = getUserCurrentLocation();

        if (currentCoords.lat && currentCoords.lng) {
          const filteredCinemas = cinemas.filter(cinema => {
            const distance = calculateDistance(currentCoords.lat, currentCoords.lng, cinema.latitude, cinema.longitude, 'K');
            return distance <= searchRadius;
          });

          setCinemasList(filteredCinemas);
        } else {
          setCinemasList([]);
        }
      }

      filterAreaCinemas();
    }
  }, [location, useCurrentLocation, cinemas]);

  const getUserCurrentLocation = () => {
    // const coordinates = {
    //   lat: null,
    //   lng: null
    // };

    const coordinates = {
      lat: 43.234135099999996,
      lng: 27.8951277
    };

    if ("geolocation" in navigator) {
      console.log("'geolocation' is available");
    } else {
      console.log("'geolocation' is not available");
    }

    navigator.geolocation.getCurrentPosition(
      function(position) {
        coordinates.lat = position.coords.latitude;
        coordinates.lng = position.coords.longitude;
      },
      function(error) {
        console.error("Error Code = " + error.code + " - " + error.message);
      }
    );

    return coordinates;
  }

  const calculateDistance = (lat1, lon1, lat2, lon2, unit) => {
    if ((lat1 === lat2) && (lon1 === lon2)) {
      return 0;
    } else {
      var radlat1 = Math.PI * lat1/180;
      var radlat2 = Math.PI * lat2/180;
      var theta = lon1-lon2;
      var radtheta = Math.PI * theta/180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      
      if (dist > 1) {
        dist = 1;
      }
      
      dist = Math.acos(dist);
      dist = dist * 180/Math.PI;
      dist = dist * 60 * 1.1515;
      
      if (unit==="K") { dist = dist * 1.609344 }
      if (unit==="N") { dist = dist * 0.8684 }
      
      return dist;
    }
  }

  return (
    <div className={styles.sectionCinemas + ' ' + (isDropDownLayout && isPopup ? styles.dropDownLayout : '')}>
      {/*
      {cinemasList.length > 0 && 
        <p className={styles.listTitle}>{window.mapiTranslations['Select a cinema in the area']}</p>
      }
      */}

      <div className="cinemas">
        {
          cinemasList.map((cinemaData, index) => {
            return (
              <Cinema 
                key={cinemaData.id || index}
                cinemaData={cinemaData} 
                setFilter={setFilter}
                isPopup={isPopup}
                homeURL={homeURL}
                useSiteAsFilter={useSiteAsFilter}
                setActiveTab={setActiveTab}
                colorScheme={colorScheme}
                concessionBtnText={concessionBtnText}
                concessionSiteLink={concessionSiteLink}
                concessionLinkNewTab={concessionLinkNewTab}
                concessionEnabledParam={concessionEnabledParam}
                testCinemasEnabled={testCinemasEnabled} 
              />
            );
          })
        }
      </div>
    </div>
  );
}

export { Cinemas };

